<template>
  <div>
    <v-app-bar flat color="transparent" class="main-appbar">
      <app-bar-nav-icon />
      <v-toolbar-title
        class="breadcrumbs d-flex align-center"
        v-if="$router.currentRoute.name !== 'settings.dashboard'"
      >
        <v-icon class="text-light-blue">{{ icons.arrowLeft }}</v-icon>
        <router-link class="text-decoration--none" :to="{ name: 'settings' }"
          >Settings</router-link
        >
      </v-toolbar-title>
      <v-toolbar-title class="headline font-weight-bold" v-else
        >Settings</v-toolbar-title
      >
    </v-app-bar>
    <router-view />
  </div>
</template>

<script>
import { mdiChevronLeft } from '@mdi/js'
import ControlsMixin from '@/utils/mixins/Controls'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'

export default {
  name: 'SettingsPage',

  mixins: [ControlsMixin],

  components: {
    AppBarNavIcon,
  },

  data() {
    return {
      icons: {
        arrowLeft: mdiChevronLeft,
      },
    }
  },
}
</script>
